import type { LocaleMorpheus } from "@solvari/translations";
import type { SolvariEnv } from "@solvari/utils";

import { kyNoCredentials, memoize } from "@solvari/utils";

import { internalOrigin } from "~/shared/libs/internalOrigin.ts";

// Not the credentialed `ky`: its 401 hook reads `window.location` → "window is not defined".
// No staleTime: env is process-lifetime constant; `memoize` evicts on rejection.
const getSolvariEnv: (locale: LocaleMorpheus) => Promise<SolvariEnv> = memoize(
  (locale: LocaleMorpheus) =>
    kyNoCredentials
      .get(`${internalOrigin}/cache-proxy/api/v3/solvari-env`, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { "solvari-locale": locale },
        timeout: 20_000,
      })
      .json<SolvariEnv>(),
);

export { getSolvariEnv };
